
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ContentView,
} from '../models';
import {
    ContentViewFromJSON,
    ContentViewToJSON,
} from '../models';

export interface CguRequest {
    version?: string;
}

/**
 * 
 */
export class LegalApiApi extends runtime.BaseAPI {

    /**
          */
    async cguRaw(requestParameters: CguRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/cgu`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async cgu(requestParameters: CguRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.cguRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async impressumRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/impressum`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async impressum(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.impressumRaw(initOverrides);
        return response._data;
    }

}
